import React from 'react'
import { flowRight } from 'lodash'
import { withRouter } from 'react-router-dom'
import { withTranslationCustom } from 'lib/i18next'
import { graphql } from '@apollo/client/react/hoc'
import { withErrorBoundaryNoRender } from 'lib/errorBoundary'
import { fetchPolicy } from 'lib/apolloFetchPolicy'
import { graphqlCurrentUserCached } from 'lib/utils/store/currentUser'

import ControlledModal from 'components//Modal/ControlledModal'
import PurchaseInformation from './PurchaseInformation'
import Loading from 'components/Util/Loading'

import getVehicleProfileView from 'graphql/view/getVehicleProfileView.gql'

const PurchaseInformationModal = ({ t, data }) => {
    const { loading, error, vehicle } = data

    return (
        <ControlledModal
            routedModal
            name="purchase-info-modal"
            context="purchaseInfoModal"
            initialTitle={t('vehicleProfile:sections.purchase.title')}
            requireUserInput={false}
        >
            {(modalProps) => (
                <Loading loading={loading} error={error}>
                    {() => (
                        <PurchaseInformation
                            isEditing={true}
                            vehicle={vehicle}
                            onSubmitted={modalProps.closeModal}
                            onCancel={modalProps.closeModal}
                        />
                    )}
                </Loading>
            )}
        </ControlledModal>
    )
}

export default flowRight(
    withErrorBoundaryNoRender,
    withTranslationCustom(['vehicleProfile']),
    withRouter,
    graphqlCurrentUserCached,
    graphql(getVehicleProfileView, {
        options: ({ match, currentUser }) => ({
            variables: {
                vehicleId: match.params.vehicleId,
                userId: currentUser.me.id,
            },
            fetchPolicy: fetchPolicy.NETWORK_ONLY,
        })
    }),
)(PurchaseInformationModal)
